import React from 'react';
import footerLogo from '../assets/images/logo/logo1.png';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Company Info */}
          <div>
            <img src={footerLogo} alt="Siddhivinayak Employment Services Logo" className="h-10 sm:h-12 md:h-14 w-auto mb-3 object-contain" />
            <h3 className="text-lg sm:text-xl font-bold text-blue-400 mb-3">
              Siddhivinayak Employment Services
            </h3>
            <p className="text-gray-300 leading-relaxed mb-3 text-xs sm:text-sm">
              Your trusted partner for professional consulting services. 
              We help businesses achieve their goals through strategic guidance 
              and innovative solutions.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="text-gray-300 hover:text-blue-400 transition duration-300">
                <span className="sr-only">Facebook</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-blue-400 transition duration-300">
                <span className="sr-only">Twitter</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-blue-400 transition duration-300">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-300 hover:text-blue-400 transition duration-300">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-300 hover:text-blue-400 transition duration-300">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-blue-400 transition duration-300">
                  Services
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-blue-400 transition duration-300">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3">Contact Info</h3>
            <div className="space-y-2 text-xs sm:text-sm">
              <div className="flex items-start space-x-3">
                <span className="text-blue-400 mt-1">📍</span>
                <div>
                  <p className="text-gray-300">
                    Office No -3, Chaitnya Vilas Apartment,<br />
                    Chhatrapati Chauk, Shivaji Nagar, Sinnar,<br />
                    Maharashtra (India)
                  </p>
                </div>
              </div>
              {/* Additional Office Address */}
              <div className="flex items-start space-x-3">
                <span className="text-blue-400 mt-1">📍</span>
                <div>
                  <p className="text-gray-300">
                    Siddhivinayak Employment Services,<br />
                    Shop NO. 315, 3rd Floor, Roongta Majestic Apartment,<br />
                    Kamod Nagar, Nashik – 422009, Maharashtra
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-blue-400">🌐</span>
                <a href="https://www.siddhivinayakemployment.com" className="text-gray-300 hover:text-blue-400 transition" target="_blank" rel="noreferrer">
                  www.siddhivinayakemployment.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-blue-400">✉️</span>
                <a href="mailto:siddhivinayakemployment@gmail.com" className="text-gray-300 hover:text-blue-400 transition">
                  siddhivinayakemployment@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-blue-400">📞</span>
                <a href="tel:7774811211" className="text-gray-300 hover:text-blue-400 transition">
                  777-481-1211
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-blue-400">☎️</span>
                <a href="tel:02534013745" className="text-gray-300 hover:text-blue-400 transition">
                  0253-4013745
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-6 pt-6 text-center">
          <p className="text-gray-300 text-sm">
            © 2024 Siddhivinayak Employment Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
